module.exports = __webpack_public_path__ + "img/icon-none.a6de76cb.png";